import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

import * as d3 from 'd3';
import * as Constants from "./Constants.js";

import {
  Button,
  Card,
  CardBody,
  CardText,
  Collapse,
  Spinner,
  Container, 
  Row, 
  Col
} from 'reactstrap';

import axios from 'axios';

import { FaHome, FaDownload, FaRegCircle, FaRegDotCircle, FaChevronCircleDown, FaChevronCircleUp } from 'react-icons/fa'

// ref. https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook
// ref. https://github.com/react-bootstrap-table/react-bootstrap-table2/tree/master/docs
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';

import ReactTooltip from 'react-tooltip';

import SequenceLogo from './seqlogo';

const convert = require('xml-js');

class ViewPanelV2 extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      clientWidth: -1,
      clientHeight: -1,
      clientMargin: 12,
      clientPadding: 12,
      navbarHeight: 0,
      openClose: {
        discoveredMotifs: true,
        jobSummary: true,
        motifDetails: true,
        motifConsensusSequence: true,
        motifSites: true,
        motifLocations: true,
        motifLocationSites: true,
        downloads: true,
        epilogosMEMEDownloads: true,
        analysisDownloads: true,
      },
      visible: {
        motifLocations: true,
      },
      memeXML: "",
      memeJSON: null,
      memeJSONAsText: "",
      memeDataAvailable: false,
      memeMotifs: null,
      memeTrainingSequences: {},
      jobMetadata: null,
      motifKey: 0,
      currentMotifIdx: 0,
      currentLocationSelection: "viewMotifAndScannedLocations",
      locationTooltipHTML: "",
      noaxisSeqlogoElements: [],
      noaxisSeqlogoHTMLs: []
    }
    this.handleAnchorClick = this.handleAnchorClick.bind(this);
    this.downloadResultsButton = React.createRef();
    this.downloadJSONButton = React.createRef();
    this.locationTooltipRef = React.createRef();
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  
  componentDidMount() {
    let self = this;
    window.addEventListener("resize", this.updateDimensions);
    axios.get(this.props.xmlURL)
      .then(function(response) {
        const memeXML = response.data;
        let memeJSON = null;
        try {
          memeJSON = convert.xml2js(memeXML, {compact: true, spaces: 2});  
          //console.log("convert.xml2js memeJSON", memeJSON);
        }
        catch(error) {
          console.error("convert.xml2js error", error);
        }
        if (!memeJSON) {
          self.setState({
            motifKey: -1
          }, () => {
            //console.log("memeJSON is null; returning");
          });
          return;
        }
        //console.log("generating training sequences...")
        /*
          Training sequences
          { sequence_0: {index: 0, name: "seq_hg19_observed_aux_E003_chr1:895967-901095_KLHL17_0_+", length: 123}, ... }
        */
        const memeTrainingSequenceIds = memeJSON.MEME.training_set.sequence.map(d => d._attributes.id);
        const memeTrainingSequenceNames = memeJSON.MEME.training_set.sequence.map(d => d._attributes.name);
        const memeTrainingSequenceLengths = memeJSON.MEME.training_set.sequence.map(d => d._attributes.length);
        const memeTrainingSequences = memeTrainingSequenceNames.reduce(function(result, field, index) {
          result[memeTrainingSequenceIds[index]] = { 
            index: index, 
            name: field,
            length: memeTrainingSequenceLengths[index]
          };
          return result;
        }, {});
        /*
          Motif data
        */
        //console.log("generating MEME motifs...")
        const memeJSONAsText = JSON.stringify(memeJSON, null, 2);
        const memeMotifs = self.memeMotifsFromJSON(memeJSON, memeTrainingSequences);
        //console.log(`memeMotifs: ${JSON.stringify(memeMotifs, null, 2)}`);
        /*
          Metadata 
        */
        axios.get(self.props.metadataURL)
          .then(function(response) {
            //console.log("response.data", response.data);
            const jobMetadata = response.data;
            self.setState({
              jobMetadata: jobMetadata,
              memeXML: memeXML,
              memeJSON: memeJSON,
              memeJSONText: memeJSONAsText,
              memeDataAvailable: true,
              memeMotifs: memeMotifs,
              assembly: jobMetadata.genome,
              model: Constants.epilogosMemeModelsForGenomes[jobMetadata.genome][jobMetadata.stateModel].model,
              memeTrainingSequences: memeTrainingSequences
            }, () => { 
              //console.log("loaded metadata")
              self.updateDimensions();
              self.setState({
                motifKey: Math.random()
              }, () => {
                let newNoaxisSeqlogoElements = [];
                self.state.memeMotifs.attributes.forEach((a, ai) => {
                  const noaxisSeqlogoId = `#logo-${ai}-noaxis`;
                  //console.log(`looking for ${noaxisSeqlogoId}...`);
                  //const seqlogoElement = document.getElementById(noaxisSeqlogoId);
                  const noaxisSeqlogoElement = d3.select(noaxisSeqlogoId);
                  if (noaxisSeqlogoElement) {
                    newNoaxisSeqlogoElements[ai] = noaxisSeqlogoElement;
                  }
                });
                self.setState({
                  noaxisSeqlogoElements: newNoaxisSeqlogoElements
                }, () => {
                  //console.log("self.state.noaxisSeqlogoElements", self.state.noaxisSeqlogoElements);
                  let newNoaxisSeqlogoHTMLs = [];
                  self.state.noaxisSeqlogoElements.forEach((e, ei) => {
                    //console.log(`noaxisSeqlogoElement as HTML ${ei} ${e.html()}`);
                    newNoaxisSeqlogoHTMLs[ei] = e.html();
                  });
                  self.setState({
                    noaxisSeqlogoHTMLs: newNoaxisSeqlogoHTMLs
                  });
                });
              });
            });
          })
          .catch(function(error) {
              //console.log(error);
              if (error.response) {
                console.log(JSON.stringify(error.response.data));
                console.log(error.response.status);
                console.log(error.response.headers);
                switch (error.response.status) {
                  case 400:
                  case 403:
                  case 404:
                    console.log("40x error");
                    break;
                  default:
                    break;
                }
              }
            });
      })
      .catch(function(error) {
          //console.log(error);
          if (error.response) {
            console.log(JSON.stringify(error.response.data));
            console.log(error.response.status);
            console.log(error.response.headers);
            switch (error.response.status) {
              case 400:
              case 403:
              case 404:
                console.log("40x error");
                break;
              default:
                break;
            }
          }
        });
  }
  
  componentDidUpdate() {
    if (!window.location) return;
    let hash = window.location.hash.replace('#', '');
    if (hash) {
      let node = ReactDOM.findDOMNode(this.refs[hash]);
      if (node) {
        node.scrollIntoView();
      }
    }
  }
  
  handleAnchorClick(o) {
    //window.location.href = o.href;
    window.open(o.href, '_top');
  }
  
  handleClick = (event) => {
    //console.log("handleClick", event.target.name, event.target.dataset, event.target.dataset.id, event.target.dataset.idx, event.target.dataset.name);
    var self = this;
    document.activeElement.blur();
    event.preventDefault();
    event.stopPropagation();
    //var targetAttr = event.target.target;
    var name = event.target.name;
    if (name === 'downloadResults') {
      axios.get(this.props.archiveURL, { responseType: 'blob' })
        .then(function(response) {
          let id = self.props.uuid;
          let fn = "epilogos-meme." + id + ".tbz2";
          self.downloadBlobAsFile(new Blob([response.data], {type: "application/bzip2"}), fn);
        })
        .catch(function(error) {
          console.log(error);
        })
    }
    else if (name === 'downloadJSONEpilogosMEME') {
      let blob = new Blob([JSON.stringify(this.state.memeJSON)], {type: "application/json"});
      let url = window.URL.createObjectURL(blob);
      this.downloadURI(url, "meme.json");
      window.URL.revokeObjectURL(url);
    }
    else if (name === 'downloadJSONAnalysis') {
      let blob = new Blob([JSON.stringify(this.state.jobMetadata)], {type: "application/json"});
      let url = window.URL.createObjectURL(blob);
      this.downloadURI(url, "analysis.json");
      window.URL.revokeObjectURL(url);
    }
    else if ((name === 'downloadSVG') || (event.target.dataset.id === 'SVG')) {
      //console.log("event.target.dataset.idx", event.target.dataset.idx);
      const idx = event.target.dataset.idx; //this.state.currentMotifIdx;
      const name = this.state.memeMotifs.attributes[idx].name;
      const alt = this.state.memeMotifs.attributes[idx].alt;
      const svg = document.getElementById(`logo-${idx}-${name}`);
      const serializer = new XMLSerializer();
      let source = serializer.serializeToString(svg);
      source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
      let blob = new Blob([source], {type: "image/svg+xml"});
      let url = window.URL.createObjectURL(blob);
      this.downloadURI(url, `${alt}.${name}.svg`);
      setTimeout(function() {
        window.URL.revokeObjectURL(url);
      }, 1000);
    }
  }
  
  handleLocationsClick = (name) => {
    this.setState({
      currentLocationSelection: name
    });
  }
  
  downloadBlobAsFile = (blob, fileName) => {
    var a = document.createElement("a");
    var objectURL = URL.createObjectURL(blob);
    a.href = objectURL;
    a.style.display = "none";
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    setTimeout(function(){
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectURL);  
    }, 100);
  }
  
  updateDimensions = () => {
    let windowInnerHeight = document.documentElement.clientHeight + "px";
    let windowInnerWidth = document.documentElement.clientWidth + "px";
    this.setState({
      clientWidth: windowInnerWidth,
      clientHeight: windowInnerHeight,
      motifKey: Math.random()
    });
  }
  
  flipOpenClose = (name) => {
    let newHSState = this.state.openClose[name];
    let newOpenClose = {...this.state.openClose, [name]:!newHSState};
    //console.log(JSON.stringify(newOpenClose));
    this.setState({
      openClose: newOpenClose
    });
  }
  
  downloadURI = (uri, name) => {
    let link = document.createElement("a");
    link.download = name;
    link.href = uri;
    link.style.display = "none";
    document.body.appendChild(link);
    if (typeof MouseEvent !== "undefined") {
      link.dispatchEvent(new MouseEvent("click"));
    } 
    else {
      link.click();
    }
    document.body.removeChild(link);
  }
  
  jobSummary = () => {
    return (
      <div>
        <Container style={{}} className="remove-all-margin-padding">
          <Row>
            <Col xs="6">
              <BootstrapTable 
                keyField='type' 
                data={this.jobSummaryLeftDataTable()}
                columns={this.jobSummaryColumns()} 
                bootstrap4={true} 
                bordered={false}
                classes="data-table"
                />
            </Col>
            <Col xs="6">
              <BootstrapTable 
                keyField='type' 
                data={this.jobSummaryRightDataTable()}
                columns={this.jobSummaryColumns()} 
                bootstrap4={true} 
                bordered={false}
                classes="data-table"
                />
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
  
  jobSummaryRightDataTable = () => {
    const md = this.state.jobMetadata;
    let data = [];
    const jobSummaryDataTableRow = {
      'type' : "",
      'value' : ""
    };
    
    const background = Object.assign({}, jobSummaryDataTableRow);
    background.type = "Background model";
    background.value = `${Constants.epilogosMemeBackgrounds[md.background]}`;
    data.push(background);
    
    const siteDistribution = Object.assign({}, jobSummaryDataTableRow);
    siteDistribution.type = "Site distributions";
    siteDistribution.value = `${Constants.epilogosMemeMotifSiteDistributions[md.siteDistribution]}`;
    data.push(siteDistribution);
    
    const prior = Object.assign({}, jobSummaryDataTableRow);
    prior.type = "Prior";
    prior.value = `${Constants.epilogosMemePriors[md.prior]}`;
    data.push(prior);
    
    return data;
  }
  
  jobSummaryLeftDataTable = () => {
    const md = this.state.jobMetadata;
    let data = [];
    const jobSummaryDataTableRow = {
      'type' : "",
      'value' : ""
    };
    
    const assembly = Object.assign({}, jobSummaryDataTableRow);
    assembly.type = "Assembly";
    assembly.value = `${md.genome} (${Constants.epilogosMemeGenomeSpecies[md.genome]})`;
    data.push(assembly);
    
    const model = Object.assign({}, jobSummaryDataTableRow);
    model.type = "State model";
    model.value = md.stateModel;
    data.push(model);
    
    const biosample = Object.assign({}, jobSummaryDataTableRow);
    biosample.type = "Epigenome sample";
    biosample.value = `${md.sample} (${Constants.epilogosMemeSamplesKV[md.genome][md.sample]})`;
    data.push(biosample);
    
    return data;
  }
  
  jobSummaryColumns = () => {
    const seqlogoWidth = (this.state.clientWidth) ? parseInt(this.state.clientWidth)/3 : 600;
    const typeWidth = "150px";
    //const valueWidth = ((seqlogoWidth/2) + 50) + "px";
    const columns = [
      {
        dataField: 'type',
        text: '',
        headerStyle: {
          maxHeight: '1px',
          height: '1px',
          width: typeWidth,
          minWidth: typeWidth,
          //borderBottom: '1px solid #b5b5b5',
        },
        style: {
          fontSize: '0.8em',
          fontWeight: 600,
          width: typeWidth,
          minWidth: typeWidth,
          outlineWidth: '0px',
          marginLeft: '4px',
          paddingTop: '3px',
          paddingBottom: '3px',
          textAlign: 'left',
        },
        sort: false
      },
      {
        dataField: 'value',
        text: '',
        headerStyle: {
          maxHeight: '1px',
          height: '1px',
          width: seqlogoWidth,
          borderBottom: '1px solid #b5b5b5',
        },
        style: {
          fontFamily: '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',
          fontWeight: 'normal',
          fontSize: '0.8em',
          outlineWidth: '0px',
          paddingTop: '4px',
          paddingBottom: '3px',
          paddingRight: '2px',
          width: seqlogoWidth,
        },
        sort: false
      }
    ];
    return columns;
  }
  
  changeCurrentMotifIdx = (i) => {
    if (i === this.state.currentMotifIdx) return;
    this.setState({
      currentMotifIdx: i
    });
  }
  
  memeMotifsFromJSON = (o, ts) => {
    //console.log("memeMotifsFromJSON", JSON.stringify(o, null, 2));
    //let self = this;
    
    let items = [];
    let attributes = [];
    let sites = [];
    let sequences_id_to_attr = {};
    let motifs_id_to_attr = {};
    /*
      Version
    */
    if (!o.MEME || !o.MEME._attributes || !o.MEME._attributes.version) {
      throw new Error("MEME object lacks version attribute");
    }
    const memeVersion = o.MEME._attributes.version;
    if (!o.MEME || !o.MEME.training_set || !o.MEME.training_set.alphabet || !o.MEME.training_set.alphabet.letter) {
      throw new Error("MEME object does not define alphabet array");
    }
    
    /*
      Assembly
    */
    const assembly = this.state.assembly;
    
    /*
      Model
    */
    const model = this.state.model;
    
    /*
      Alphabet
    */
    let alphabet = [];
    const alphabetLength = o.MEME.training_set.alphabet.letter.length - 1;
    o.MEME.training_set.alphabet.letter.forEach((l, i) => {
      if (i < alphabetLength) {
        if (!l._attributes || !l._attributes.symbol) {
          throw new Error("MEME object alphabet array element lacks attributes or symbol");
        }
        alphabet.push(l._attributes.symbol);
      }
    });
    const memeAlphabet = alphabet.join('');
    
    /*
      Sequences
       +
      Background frequencies
    */
    if (!o.MEME || !o.MEME.model || !o.MEME.model.background_frequencies || !o.MEME.model.background_frequencies._attributes || !o.MEME.model.background_frequencies._attributes.source) {
      throw new Error("MEME object lacks background frequency source path");
    }
    const memeBackgroundFrequencyPath = o.MEME.model.background_frequencies._attributes.source;
    if (!o.MEME || !o.MEME.training_set || !o.MEME.training_set.sequence || !o.MEME.training_set.letter_frequencies || !o.MEME.training_set.letter_frequencies.alphabet_array || !o.MEME.training_set.letter_frequencies.alphabet_array.value) {
      throw new Error("MEME object lacks background frequencies");
    }
    o.MEME.training_set.sequence.forEach((s, si) => {
      sequences_id_to_attr[s._attributes.id] = {
        index: si,
        name: s._attributes.name,
        length: parseInt(s._attributes.length),
        weight: parseFloat(s._attributes.weight)
      };
    });
    //console.log("sequences_id_to_attr", JSON.stringify(sequences_id_to_attr, null, 2));
    let backgroundFrequencies = [];
    o.MEME.training_set.letter_frequencies.alphabet_array.value.forEach((f) => {
      if (!f._attributes || !f._attributes.letter_id || !f._text) {
        throw new Error("MEME object lacks background frequency information for residue");
      }
      backgroundFrequencies.push(f._attributes.letter_id);
      backgroundFrequencies.push(f._text);
    });
    const memeBackgroundFrequencies = backgroundFrequencies.join(' ');
    
    /*
      Motifs
    */
    if (!o.MEME || !o.MEME.motifs || !o.MEME.motifs.motif) {
      throw new Error("MEME object does not define motifs array");
    }
    o.MEME.motifs.motif.forEach((m, mi) => {
      /*
        Attributes
      */
      if (!m._attributes || !m._attributes.id || !m._attributes.name || !m._attributes.alt || !m._attributes.width || !m._attributes.sites || !m._attributes.e_value || !m._attributes.llr || !m._attributes.ic || !m._attributes.re) {
        throw new Error("MEME object motif instance lacks required attributes");
      }
      const memeMotifId = m._attributes.id;
      const memeMotifName = m._attributes.name;
      const memeMotifAlt = m._attributes.alt;
      const memeMatrixW = m._attributes.width;
      const memeMatrixALength = memeAlphabet.length;
      const memeMatrixNSites = m._attributes.sites;
      const memeMatrixEValue = m._attributes.e_value;
      const memeMotifLogLikelihoodRatio = m._attributes.llr;
      const memeMotifInformationContent = m._attributes.ic;
      const memeMotifRelativeEntropy = m._attributes.re;
      const memeMotifBayesThreshold = m._attributes.bayes_threshold;
      motifs_id_to_attr[memeMotifId] = {
        idx : mi,
        name : memeMotifName, 
        alt : memeMotifAlt, 
      };
      attributes.push({
        id: memeMotifId,
        name: memeMotifName,
        alt: memeMotifAlt,
        width: memeMatrixW,
        aLength: memeMatrixALength,
        sites: memeMatrixNSites,
        e_value: memeMatrixEValue,
        log_likelihood_ratio: memeMotifLogLikelihoodRatio,
        information_content: memeMotifInformationContent,
        relative_entropy: memeMotifRelativeEntropy,
        bayes_threshold: memeMotifBayesThreshold
      });      
      /*
        Probabilities
      */
      if (!m.probabilities || !m.probabilities.alphabet_matrix || !m.probabilities.alphabet_matrix.alphabet_array) {
        throw new Error("MEME object motif instance lacks required letter-probability matrix array");
      }
      let memeMatrixFrequencies = "";
      m.probabilities.alphabet_matrix.alphabet_array.forEach((fs, fsi) => {
        if (!fs.value) {
          throw new Error("MEME object letter-probability matrix array instance lacks value data");
        }
        fs.value.forEach((f, fi) => {
          if (!f._text) {
            throw new Error("MEME object letter-probability matrix array instance lacks frequency for value instance");
          }
          memeMatrixFrequencies += ` ${f._text} `;
        });
        memeMatrixFrequencies += '\n';
      })
      /*
        Contributing sites
      */
      let memeMotifContributingSites = [];
      if (!m.contributing_sites || !m.contributing_sites.contributing_site) {
        throw new Error("MEME object motif instance lacks contributing site data");
      }
      m.contributing_sites.contributing_site.forEach((cs, csi) => {
        if (!cs._attributes || !cs._attributes.sequence_id || !cs._attributes.position || !cs._attributes.strand || !cs._attributes.pvalue) {
          throw new Error("MEME object motif's contributing site lacks needed attributes");
        }
        if (!cs.left_flank || !cs.site || !cs.site.letter_ref || !cs.right_flank) {
          throw new Error("MEME object motif's contributing site lacks needed flank and site data");
        }
        const site_letters = cs.site.letter_ref.map(d => d._attributes.letter_id);
        const site_sequence = site_letters.join('');
        //console.log("ts", JSON.stringify(ts, null, 2));
        //console.log("ts[cs._attributes.sequence_id]", cs._attributes.sequence_id, ts[cs._attributes.sequence_id]);
/*
        sequences_id_to_attr[cs._attributes.sequence_id] = {
          index: ts[cs._attributes.sequence_id].index,
          name: ts[cs._attributes.sequence_id].name,
          length: ts[cs._attributes.sequence_id].length
        };
*/
        memeMotifContributingSites.push({
          index: csi,
          sequence_id: cs._attributes.sequence_id,
          sequence_name: ts[cs._attributes.sequence_id].name,
          sequence_index: ts[cs._attributes.sequence_id].index,
          position: cs._attributes.position,
          strand: cs._attributes.strand,
          p_value: cs._attributes.pvalue,
          left_flank: (cs.left_flank._text) ? cs.left_flank._text : "",
          sites: site_sequence,
          right_flank: (cs.right_flank._text) ? cs.right_flank._text : ""
        });
      });
      sites.push(memeMotifContributingSites);
      /*
        Items (for react-seqlogo <SequenceLogo items=... />)
      */
      items.push(`MEME version ${memeVersion}

ALPHABET= ${memeAlphabet}

Background letter frequencies (from ${memeBackgroundFrequencyPath}):
${memeBackgroundFrequencies}

MOTIF ${memeMotifName} ${memeMotifAlt}

letter-probability matrix: alength= ${memeMatrixALength} w= ${memeMatrixW} nsites= ${memeMatrixNSites} E= ${memeMatrixEValue} 
${memeMatrixFrequencies}`);
    });
    
    
    /*
      Locations
    */
    //console.log("sequences_id_to_attr", sequences_id_to_attr);
    let locations = { p_threshold : 0, sites : [] };
    if (!o.MEME || !o.MEME.scanned_sites_summary || !o.MEME.scanned_sites_summary._attributes || !o.MEME.scanned_sites_summary.scanned_sites) {
      throw new Error("MEME object does not define scanned sites data");
    }
    locations.p_threshold = o.MEME.scanned_sites_summary._attributes.p_thresh;
    o.MEME.scanned_sites_summary.scanned_sites.forEach((ss, ssi) => {
      //console.log("-ssi", ssi);
      if (!ss._attributes || !ss._attributes.sequence_id || !ss._attributes.pvalue) {
        //console.log("-ssi XXX", ssi);
        throw new Error("MEME object scanned sites data object lacks required attributes");
      }
      //console.log("+ssi", ssi);
      
      let scanned_sites = [];
      let motif_sites = [];
      if (parseInt(ss._attributes.num_sites) !== 0) {
        //console.log("looking in scanned_site parameter...");
        if (ss.scanned_site) {
          // scanned_site property can be an Object or Array
          if (Array.isArray(ss.scanned_site)) {
            ss.scanned_site.forEach((ssss, ssssi) => {
              scanned_sites.push({
                motif_idx: motifs_id_to_attr[ssss._attributes.motif_id].idx,
                motif_id: ssss._attributes.motif_id,
                motif_name: motifs_id_to_attr[ssss._attributes.motif_id].name,
                motif_alt: motifs_id_to_attr[ssss._attributes.motif_id].alt,
                strand: (ssss._attributes.strand === "plus") ? "+" : "-",
                position: parseInt(ssss._attributes.position),
                p_value: Number(ssss._attributes.pvalue),
              });
            });
          }
          else {
            scanned_sites.push({
              motif_id: ss.scanned_site._attributes.motif_id,
              motif_name: motifs_id_to_attr[ss.scanned_site._attributes.motif_id].name,
              motif_alt: motifs_id_to_attr[ss.scanned_site._attributes.motif_id].alt,
              strand: (ss.scanned_site._attributes.strand === "plus") ? "+" : "-",
              position: parseInt(ss.scanned_site._attributes.position),
              p_value: Number(ss.scanned_site._attributes.pvalue),
            });
          }
        }
        //console.log("looking in motifs...");
        o.MEME.motifs.motif.forEach((m, mi) => {
          m.contributing_sites.contributing_site.forEach((cs, csi) => {
            if (cs._attributes.sequence_id === ss._attributes.sequence_id) {
              const site_letters = cs.site.letter_ref.map(d => d._attributes.letter_id);
              const site_sequence = site_letters.join('');
              motif_sites.push({
                motif_idx: mi,
                motif_id: m._attributes.id,
                motif_name: m._attributes.name,
                motif_alt: m._attributes.alt,
                strand: (cs._attributes.strand === "plus") ? "+" : "-",
                position: parseInt(cs._attributes.position),
                p_value: Number(cs._attributes.pvalue),
                left_flank: (cs.left_flank._text) ? cs.left_flank._text : "",
                sites: site_sequence,
                right_flank: (cs.right_flank._text) ? cs.right_flank._text : ""
              });
            }
          });
        });
      }
      
      const seq_attr = sequences_id_to_attr[ss._attributes.sequence_id];
      const seq_idx = (seq_attr && (typeof seq_attr.index !== "undefined")) ? seq_attr.index : "";
      const seq_name = (seq_attr && seq_attr.name) ? seq_attr.name : ss._attributes.sequence_id;
      const seq_length = (seq_attr && seq_attr.length) ? seq_attr.length : 0;
      let lo = {
        'sequence_id' : ss._attributes.sequence_id,
        'sequence_idx' : seq_idx,
        'sequence_name' : seq_name,
        'sequence_length' : seq_length,
        'p_value' : Number(ss._attributes.pvalue),
        'num_sites' : parseInt(ss._attributes.num_sites),
        'scanned_sites' : scanned_sites,
        'motif_sites' : motif_sites
      };
      //console.log("+lo", lo);
      locations.sites.push(lo);
    });
    //console.log(JSON.stringify(locations, null, 2));
    
    return {
      items: items,
      attributes: attributes,
      alphabet: memeAlphabet,
      assembly: assembly,
      model: model,
      sites: sites,
      locations: locations
    };
  }
  
  motifStatisticsDataTable = (i) => {
    const currentMotifIndex = i;
    const attributes = this.state.memeMotifs.attributes;
    let data = [];
    const motifStatisticsDataTableRow = {
      'type' : '.',
      'score' : 0.0
    };
    
    const eValueRow = Object.assign({}, motifStatisticsDataTableRow);
    eValueRow.type = "E-value";
    eValueRow.score = attributes[currentMotifIndex].e_value;
    data.push(eValueRow);
    
    const sitesRow = Object.assign({}, motifStatisticsDataTableRow);
    sitesRow.type = "Sites"
    sitesRow.score = attributes[currentMotifIndex].sites;
    data.push(sitesRow);
    
    const widthRow = Object.assign({}, motifStatisticsDataTableRow);
    widthRow.type = "Width"
    widthRow.score = attributes[currentMotifIndex].width;
    data.push(widthRow);
/*
    const llrRow = Object.assign({}, motifStatisticsDataTableRow);
    llrRow.type = "Log-likelihood ratio";
    llrRow.score = attributes[currentMotifIndex].log_likelihood_ratio;
    data.push(llrRow);
    
    const icRow = Object.assign({}, motifStatisticsDataTableRow);
    icRow.type = "Information content";
    icRow.score = attributes[currentMotifIndex].information_content;
    data.push(icRow);
    
    const reRow = Object.assign({}, motifStatisticsDataTableRow);
    reRow.type = "Relative entropy";
    reRow.score = attributes[currentMotifIndex].relative_entropy;
    data.push(reRow);
    
    const btRow = Object.assign({}, motifStatisticsDataTableRow);
    btRow.type = "Bayes threshold";
    btRow.score = attributes[currentMotifIndex].bayes_threshold;
    data.push(btRow);
*/
    
    return data;
  }
  
  formattedMotifName = (name, opacity, category, align) => {
    if (!opacity) opacity = 1;
    if (!align) align = "left";
    function hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
    return name.split('').map((l, li) => {
      const rgb = hexToRgb(Constants.colormap[this.state.assembly][this.state.model][l]);
      const color = `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`;
      return (
        <span 
          key={`${category}-${l}-${li}`} 
          className="formatted-motif-name-element"
          onMouseMove={(e) => {
            const description = Constants.epilogosLetterToState(this.state.assembly, this.state.model, l);
            const tooltip = document.getElementById("view-container-tooltip");
            const section = (category === "left_flank") ? " | Left flank" : (category === "right_flank") ? " | Right flank" : (category === "center") ? " | Motif" : "";
            tooltip.innerHTML = `${description}${section}`;
            tooltip.style.display = "block";
            const rect = tooltip.getBoundingClientRect();
            //console.log("align");
            if (align === "left") {
              tooltip.style.left = e.pageX - 5 - rect.width + 'px';
              tooltip.style.top = e.pageY - 5 - rect.height + 'px';
            }
            else if (align === "right") {
              tooltip.style.left = e.pageX + 10 + 'px';
              tooltip.style.top = e.pageY - 5 - rect.height + 'px';              
            }
          }} 
          onMouseOut={(e) => {
            const tooltip = document.getElementById("view-container-tooltip");
            tooltip.style.display = "none";
          }}
          style={{cursor:'pointer', color:color}}>
          &#x2588;
        </span>
      );
    });
  }
  
  consensusSequence = (i) => {
    const name = this.state.memeMotifs.attributes[i].name;
    return (
      <span style={{}}>
        {this.formattedMotifName(name, 1.0, null, "right")}
      </span>
    );
  }
  
  locationsTable = (lt) => {
    return (
      <div style={{marginTop:"15px"}}>
        <table id="locations-table" className="locations-table">
          <thead>
            {this.locationsTableHeader()}
          </thead>
          <tbody>
            {this.locationTableBodyRows(lt)}
          </tbody>
        </table>
      </div>
    );
  }
  
  locationsTableHeader = () => {
    return (
      <tr>
        <th className="locations-row-header-cell locations-row-header-cell-sequence_index"></th>
        <th className="locations-row-header-cell locations-row-header-cell-sequence_name">Name</th>
        <th className="locations-row-header-cell locations-row-header-cell-pvalue"><em>p</em>-value</th>
        <th className="locations-row-header-cell locations-row-header-cell-sites-location">Motif location</th>
      </tr>
    );
  }
  
  locationTableBodyRows = (lt) => {
    if ((this.state.memeMotifs.locations.length === 0) || (this.state.memeMotifs.locations.sites.length === 0))
      return;
    const locations = this.state.memeMotifs.locations;
    let rows = [];
    //const minSequenceLength = Math.min.apply(Math, locations.sites.map(function(o) { return o.sequence_length; }));
    //const maxSequenceLength = Math.max.apply(Math, locations.sites.map(function(o) { return o.sequence_length; }));
    //console.log("length min/max", minSequenceLength, maxSequenceLength);
    locations.sites.forEach((s, si) => {
      let includeRow = false;
      if (lt === "viewAllLocations") {
        includeRow = true;
      }
      else if ((lt === "viewSelectedMotifLocations") && (s.motif_sites.length > 0)) {
        const foundSite = s.motif_sites.find((site) => site.motif_idx === this.state.currentMotifIdx);
        if (foundSite) {
          includeRow = true;
        }
      }
      else if (((lt === "viewMotifLocations") || (lt === "viewMotifAndScannedLocations")) && (s.motif_sites.length > 0)) {
        includeRow = true;
      }
      else if ((lt === "viewMotifAndScannedLocations") && (s.scanned_sites.length > 0)) {
        includeRow = true;
      }
      if (includeRow) {
        //if (si === 0) { console.log("s", JSON.stringify(s, null, 2)); }
        rows.push(
          <tr key={`locations-row-${lt}-${si}`}>
            <td className="locations-row-cell locations-row-cell-sequence_index">{s.sequence_idx + 1}.</td>
            <td className="locations-row-cell locations-row-cell-sequence_name">{s.sequence_name}</td>
            <td className="locations-row-cell locations-row-cell-pvalue">{s.p_value}</td>
            <td className="locations-row-cell locations-row-cell-location">{this.renderLocationWidget(lt, s, si, s.sequence_length)}</td>
          </tr>
        )
      }      
    })
    return rows;
  }
  
  renderLocationWidget = (lt, s, si, sl) => {
    let sequence_length = sl;
    let dims = {
      marksXStart: 20,
      marksXEnd: 400,
      svgYStart: 0,
      svgYEnd: 30,
      svgYMidpoint: 15,
    };
    
    const generateRectsFromArray = (arr, keyPrefix, fillColor, strokeColor, strokeWidth) => {
      return arr.map((as, asi) => {
        const position = as.position;
        const strand = as.strand;
        const length = ((keyPrefix === 'motif') ? 
          (as.sites.length) :
          (as.motif_name.length))
        // rescale position from [0, sequence_length] to [marksXStart, marksXEnd]
        const xStart = position * (dims.marksXEnd - dims.marksXStart) / sequence_length + (dims.marksXStart - 1);
        let xEnd = (position + length) * (dims.marksXEnd - dims.marksXStart) / sequence_length + (dims.marksXStart - 1);
        if ((xEnd - xStart) < 1) {
          xEnd = xStart + 1;
        }
        
        //if (si === 0) { console.log(si, asi, s, keyPrefix, position, strand, length, sequence_length, xStart, xEnd, xEnd - xStart); }
        
        const tooltipHTML = this.siteHTMLEntity(s, si, keyPrefix, asi);
        
        if ((si === 0) && (!tooltipHTML)) {
          console.log(si, JSON.stringify(s, null, 2), keyPrefix, asi);
        }
          
        return (
          <rect 
            key={`locations-row-location-${lt}-${si}-svg-${keyPrefix}-rect-${position}-${asi}`} 
            x={xStart} 
            y={(strand === "+" ? dims.svgYStart + ((keyPrefix === 'motif') ? dims.svgYMidpoint/2 : 0) : dims.svgYMidpoint)} 
            width={xEnd - xStart} 
            height={(keyPrefix === 'motif' ? dims.svgYMidpoint/2 : dims.svgYMidpoint)} 
            fill={fillColor}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            data-for="location-tooltip"
            data-tip={tooltipHTML}
            //data-tip="placeholder"
            ref={ref => this.locationTooltipRef = ref}
            onMouseEnter ={(e) => {
              ReactTooltip.rebuild();
              //console.log("onMouseEnter", keyPrefix, asi);
              console.log("tooltipHTML", tooltipHTML);
              ReactTooltip.show(this.locationTooltipRef);
            }}
            onMouseOut={(e) => {
              //console.log("onMouseOut", keyPrefix, asi);
              ReactTooltip.hide(this.locationTooltipRef);
            }}
          />
        );
      })
    }
    
    let motifRectFill = "#fde725";
    let motifRectStroke = "#8f820a";
    let motifRectStrokeWidth = 1;
    let motifKeyPrefix = "motif";
    let motifRects = generateRectsFromArray(s.motif_sites, motifKeyPrefix, motifRectFill, motifRectStroke, motifRectStrokeWidth);

    if (lt === "viewSelectedMotifLocations") {
      const motifSite = s.motif_sites.filter((site) => site.motif_idx === this.state.currentMotifIdx);
      //if (si === 0) console.log(JSON.stringify(motifSite, null, 2));
      motifRects = generateRectsFromArray(motifSite, 
                                          motifKeyPrefix, 
                                          motifRectFill,
                                          motifRectStroke,
                                          motifRectStrokeWidth);
    }
    
    let scannedRectFill = "#440154";
    let scannedRectStroke = "#25002e";
    let scannedRectStrokeWidth = 1;
    let scannedKeyPrefix = "scanned";
    let scannedRects = generateRectsFromArray(s.scanned_sites, 
                                              scannedKeyPrefix, 
                                              scannedRectFill,
                                              scannedRectStroke,
                                              scannedRectStrokeWidth);
    
    if ((lt === "viewAllLocations") && (s.motif_sites.length === 0) && (s.scanned_sites.length === 0)) {
      return <div>{this.locationSVGEntity(lt, si, dims, [])}</div>
    }
    
    else if (((lt === "viewSelectedMotifLocations") || (lt === "viewMotifLocations")) && (s.motif_sites.length >= 0)) { 
      return <div>{this.locationSVGEntity(lt, si, dims, motifRects)}</div>
    }
    
    else if (((lt === "viewMotifAndScannedLocations") || (lt === "viewAllLocations")) && (s.motif_sites.length >= 0) && (s.scanned_sites.length >= 0)) {
      //const allRects = motifRects.concat(scannedRects);
      //const allRects = motifRects;
      const allRects = scannedRects.concat(motifRects);
      //if (si === 0) { console.log("allRects", allRects); }
      return <div>{this.locationSVGEntity(lt, si, dims, allRects)}</div>
    }
  }
  
  siteHTMLEntity = (s, si, keyPrefix, asi) => {
    let results = "";
    const site = (keyPrefix === "motif") ? s.motif_sites[asi] : s.scanned_sites[asi];
    //if (typeof site === "undefined") console.log("si", si, "asi", asi);
    switch (keyPrefix) {
      
      case "motif":
        const leftFlankElement = this.formattedMotifName(site.left_flank, 0.35, "left_flank", "left");
        const centerElement = this.formattedMotifName(site.sites, 1.0, "center", "left");
        const rightFlankElement = this.formattedMotifName(site.right_flank, 0.35, "right_flank", "left");
        const leftFlankHTML = ReactDOMServer.renderToStaticMarkup(leftFlankElement);
        const centerHTML = ReactDOMServer.renderToStaticMarkup(centerElement);
        const rightFlankHTML = ReactDOMServer.renderToStaticMarkup(rightFlankElement);
        
        const seqlogoHTML = this.state.noaxisSeqlogoHTMLs[site.motif_idx];
        const seqlogoWidth = (this.state.clientWidth) ? parseInt(this.state.clientWidth)/3 : 600;
        const newSeqlogoWidth = 10 * site.motif_name.length;
        const rescale = newSeqlogoWidth / seqlogoWidth;
        const newSeqlogoScale = `translate(0,0) scale(${rescale} 1)`;
        
        if (!seqlogoHTML) return;
        
/*
        if (asi === 0) {
          console.log("seqlogoWidth", seqlogoWidth);
          console.log("site.motif_name.length", site.motif_name.length, "newSeqlogoWidth", newSeqlogoWidth);
          console.log("rescale", rescale);
        }  
*/      
        
        const rewidthSeqlogoHTML = seqlogoHTML.replace(/(<svg width=")(\d+)(.*)(><g transform=")(translate\(0,0\))(.*)/gm, "$1" + newSeqlogoWidth + "$3" + "$4" + newSeqlogoScale + "$6");
        
        results = `
          <div>
            <div class="location-header">Motif site</div>
            <table style="margin:0;padding:0">
              <tbody>
                <tr>
                  <td class="location-row-cell"></td>
                  <td class="location-row-cell">${rewidthSeqlogoHTML}</td>
                  <td class="location-row-cell"></td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-left_flank">${leftFlankHTML}</td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-sites">${centerHTML}</td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-right_flank">${rightFlankHTML}</td>
                </tr>
              </tbody>
            </table>
            <table style="margin-top:15px; margin-bottom:15px">
              <tbody>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Motif</td>
                  <td class="location-row-cell location-row-cell-value">${site.motif_alt}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label"><em>p</em>-value</td>
                  <td class="location-row-cell location-row-cell-value">${site.p_value}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Start</td>
                  <td class="location-row-cell location-row-cell-value">${site.position + 1}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">End</td>
                  <td class="location-row-cell location-row-cell-value">${site.position + site.motif_name.length}</td>
                </tr>
              </tbody>
            </table>
          </div>`;
        break;
        
      case "scanned":
        const centerScannedElement = this.formattedMotifName(site.motif_name, 1.0, "center", "left");
        const centerScannedHTML = ReactDOMServer.renderToStaticMarkup(centerScannedElement);
        
        const scannedSeqlogoHTML = this.state.noaxisSeqlogoHTMLs[site.motif_idx];
        const scannedSeqlogoWidth = (this.state.clientWidth) ? parseInt(this.state.clientWidth)/3 : 600;
        const newScannedSeqlogoWidth = 10 * site.motif_name.length;
        const scannedRescale = newScannedSeqlogoWidth / scannedSeqlogoWidth;
        const newScannedSeqlogoScale = `translate(0,0) scale(${scannedRescale} 1)`;
        
        if (!scannedSeqlogoHTML) return;
        
        const rewidthScannedSeqlogoHTML = scannedSeqlogoHTML.replace(/(<svg width=")(\d+)(.*)(><g transform=")(translate\(0,0\))(.*)/gm, "$1" + newScannedSeqlogoWidth + "$3" + "$4" + newScannedSeqlogoScale + "$6");
        
        results = `
          <div>
            <div class="location-header">Scanned site</div>
            <table style="margin:0;padding:0">
              <tbody>
                <tr>
                  <td class="location-row-cell"></td>
                  <td class="location-row-cell">${rewidthScannedSeqlogoHTML}</td>
                  <td class="location-row-cell"></td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-left_flank"></td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-sites">${centerScannedHTML}</td>
                  <td class="location-row-cell location-row-cell-sites-data location-row-cell-right_flank"></td>
                </tr>
              </tbody>
            </table>
            <table style="margin-top:15px; margin-bottom:15px">
              <tbody>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Motif</td>
                  <td class="location-row-cell location-row-cell-value">${site.motif_alt}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label"><em>p</em>-value</td>
                  <td class="location-row-cell location-row-cell-value">${site.p_value}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">Start</td>
                  <td class="location-row-cell location-row-cell-value">${site.position + 1}</td>
                </tr>
                <tr>
                  <td class="location-row-cell location-row-cell-label">End</td>
                  <td class="location-row-cell location-row-cell-value">${site.position + site.motif_name.length}</td>
                </tr>
              </tbody>
            </table>
          </div>`;
        break;
        
      default:
        break;
    }
    return results;
  }
  
  locationSVGEntity = (lt, si, dims, rects) => {
    const cursor = "pointer";
    return (
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={dims.marksXEnd} height={dims.svgYEnd} id={`locations-row-location-${lt}-${si}-svg`} key={`locations-row-location-${lt}-${si}-svg-key`}>
        <style>
          { `rect { cursor:${cursor} }` }
        </style>
        <g id={`locations-row-location-${lt}-${si}-svg-strand`}>
          <text x="10" y={dims.svgYMidpoint - 3} style={{textAnchor:"middle",fontFamily:"Consolas,\"Input Mono\",Monaco,Menlo,\"Courier New\",Courier,monospace"}}>+</text>
          <text x="10" y={dims.svgYEnd - 3} style={{textAnchor:"middle",fontFamily:"Consolas,\"Input Mono\",Monaco,Menlo,\"Courier New\",Courier,monospace"}}>-</text>
        </g>
        <g id={`locations-row-location-${lt}-${si}-svg-marks`}>
          {rects}
          <line x1={dims.marksXStart} y1={dims.svgYMidpoint} x2={dims.marksXEnd} y2={dims.svgYMidpoint} style={{stroke:"#000000"}} />
        </g>
      </svg>
    );
  }
  
  sitesTable = (i) => {
    return (
      <div>
        <table id="sites-table" className="sites-table">
          <thead>
            {this.sitesTableHeader()}
          </thead>
          <tbody>
            {this.sitesTableBodyRows(i)}
          </tbody>
        </table>
      </div>
    );
  }
  
  sitesTableHeader = () => {
    return (
      <tr>
        <th className="sites-row-header-cell sites-row-header-cell-index"></th>
        <th className="sites-row-header-cell sites-row-header-cell-sequence_index"></th>
        <th className="sites-row-header-cell sites-row-header-cell-sequence_name">Name</th>
        <th className="sites-row-header-cell sites-row-header-cell-strand">Strand</th>
        <th className="sites-row-header-cell sites-row-header-cell-start">Start</th>
        <th className="sites-row-header-cell sites-row-header-cell-pvalue"><em>p</em>-value</th>
        <th className="sites-row-header-cell sites-row-header-cell-sites-data"></th>
        <th className="sites-row-header-cell sites-row-header-cell-sites-data">Content</th>
        <th className="sites-row-header-cell sites-row-header-cell-sites-data"></th>
      </tr>
    );
  }
  
  sitesTableBodyRows = (i) => {
    const motifIdx = i;
    if ((this.state.memeMotifs.sites.length === 0) || (this.state.memeMotifs.sites[motifIdx].length === 0))
      return;
    const sites = this.state.memeMotifs.sites[motifIdx];
    return sites.map((s, si) => {
      return (
        <tr key={`sites-row-${motifIdx}-${i}-${si}`}>
          <td className="sites-row-cell sites-row-cell-index">{si + 1}</td>
          <td className="sites-row-cell sites-row-cell-sequence_index">{s.sequence_index + 1}.</td>
          <td className="sites-row-cell sites-row-cell-sequence_name">{s.sequence_name}</td>
          <td className="sites-row-cell sites-row-cell-strand">{(s.strand === "plus") ? "+" : "-"}</td>
          <td className="sites-row-cell sites-row-cell-start">{parseInt(s.position) + 1}</td>
          <td className="sites-row-cell sites-row-cell-pvalue">{s.p_value}</td>
          <td className="sites-row-cell sites-row-cell-sites-data sites-row-cell-left_flank">{this.formattedMotifName(s.left_flank, 0.35, "left_flank", "left")}</td>
          <td className="sites-row-cell sites-row-cell-sites-data sites-row-cell-sites">{this.formattedMotifName(s.sites, 1.0, "center", "left")}</td>
          <td className="sites-row-cell sites-row-cell-sites-data sites-row-cell-right_flank">{this.formattedMotifName(s.right_flank, 0.35, "right_flank", "left")}</td>
        </tr>
      );
    })
  }
    
  motifTable = () => {
    return (
      <div>
        <table id="motif-table">
          {/* <thead>
            {this.motifTableHeader()}
          </thead> */}
          <tbody>
            {this.motifTableBodyRows()}
          </tbody>
        </table>
      </div>
    );
  }
  
  motifTableHeader = () => {
    return (
      <tr>
        <th style={{paddingLeft:"20px"}}>
        </th>
        <th style={{paddingRight:"20px"}}>
        </th>
        <th style={{textAlign:"center"}}>
          Motif
        </th>
        <th style={{textAlign:"left", paddingLeft:"10px"}}>
          Statistics
        </th>
      </tr>
    )
  }
  
  motifTableBodyRows = () => {
    if (this.state.memeMotifs.items.length === 0) 
      return;
    //let seqlogos = [];
    const seqlogoWidth = (this.state.clientWidth) ? Math.min(parseInt(this.state.clientWidth)/3, 600) : 600;
    const seqlogoLetterWidth = seqlogoWidth - 65;
    const seqlogoMode = "MEMEMotif";
    const seqlogoType = "epilogos";
    const seqlogoHeight = Constants.seqlogoHeight;
    const seqlogoLetterHeight = Constants.seqlogoLetterHeight;
    const seqlogoMargin = {
      top : 20,
      right : 0,
      bottom : 20,
      left: 15
    };
    const seqlogoMarginNoAxis = {
      top : 0,
      right : 0,
      bottom : 0,
      left: 0
    };
    
    /*
      These need to come from somewhere else in metadata — we'll use placeholders for now
    */
    const seqlogoEpilogosAssembly = this.state.assembly;
    const seqlogoEpilogosModel = this.state.model;
    
    //console.log("seqlogoEpilogosAssembly, seqlogoEpilogosModel", seqlogoEpilogosAssembly, seqlogoEpilogosModel);
        
    return this.state.memeMotifs.items.map((m, mi) => {
      const currentMotifIdx = this.state.currentMotifIdx;
      const motifIdx = mi + 1;
      const statisticsTableWidth = "240px";
      const seqlogoColorScheme = (seqlogoEpilogosAssembly === "mm10") ? "epilogos-15state-mouse" 
        : (this.state.memeMotifs.alphabet.length === 15) ? "epilogos-15state-human" 
        : (this.state.memeMotifs.alphabet.length === 18) ? "epilogos-18state-human" : "epilogos-25state-human";
      //console.log("seqlogoColorScheme", seqlogoColorScheme);
      const seqlogoItemText = m;
      const seqlogoId = `logo-${mi}`;
      const seqlogoTitle = "";
      //const seqlogoName = this.formattedMotifName(this.state.memeMotifs.attributes[mi].name);
      
      const remainingWidth = (document.getElementById('motif-table-card')) ? document.getElementById('motif-table-card').offsetWidth - (parseInt(statisticsTableWidth) + 60 + 60 + parseInt(seqlogoWidth)) : 0;
      
      return (
        <tr key={`motif-row-${motifIdx}`} style={{cursor:"pointer"}} onClick={()=>{this.changeCurrentMotifIdx(mi);}}>
          <td style={{paddingLeft:"20px", width:"40px", fontWeight:"600", textAlign:"left", verticalAlign:"middle", backgroundColor:(mi === currentMotifIdx)?"rgba(0,0,0,0.025)":"#fff"}}>
            <span className="motif-selector" onClick={()=>{this.changeCurrentMotifIdx(mi);}}>{(mi === currentMotifIdx) ? <FaRegDotCircle /> : <FaRegCircle />}</span>
          </td>
          <td style={{width:"40px", fontWeight:"600", textAlign:"center", verticalAlign:"middle", paddingRight:"20px", backgroundColor:(mi === currentMotifIdx)?"rgba(0,0,0,0.025)":"#fff"}}>
            <span style={{position:"relative", top:"2px"}}>{(mi+1)}</span>
          </td>
          <td style={{width:seqlogoWidth, verticalAlign:"middle", textAlign:"center", backgroundColor:(mi === currentMotifIdx)?"rgba(0,0,0,0.025)":"#fff"}}>
            <SequenceLogo
              motifKey={this.state.motifKey}
              id={seqlogoId}
              title={seqlogoTitle}
              mode={seqlogoMode}
              colorScheme={seqlogoColorScheme}
              item={seqlogoItemText}
              type={seqlogoType}
              svgWidth={seqlogoWidth}
              svgHeight={seqlogoHeight}
              svgMargin={seqlogoMargin}
              svgLetterWidth={seqlogoLetterWidth}
              svgLetterHeight={seqlogoLetterHeight}
              epilogosAssembly={seqlogoEpilogosAssembly}
              epilogosModel={seqlogoEpilogosModel}
              yAxisVisible={true}
              xAxisVisible={true}
            />
            <div id={seqlogoId + "-noaxis-parent"} style={{position:"absolute",top:"-10000px"}}>
              <SequenceLogo
                motifKey={this.state.motifKey}
                id={seqlogoId + "-noaxis"}
                title={seqlogoTitle}
                mode={seqlogoMode}
                colorScheme={seqlogoColorScheme}
                item={seqlogoItemText}
                type={seqlogoType}
                svgWidth={seqlogoWidth}
                svgHeight={seqlogoHeight}
                svgMargin={seqlogoMarginNoAxis}
                svgLetterWidth={seqlogoWidth}
                svgLetterHeight={seqlogoLetterHeight}
                epilogosAssembly={seqlogoEpilogosAssembly}
                epilogosModel={seqlogoEpilogosModel}
                yAxisVisible={false}
                xAxisVisible={false}
              />
            </div>
          </td>
          <td style={{width:statisticsTableWidth, verticalAlign:"middle", backgroundColor:(mi === currentMotifIdx)?"rgba(0,0,0,0.025)":"#fff"}}>
            <BootstrapTable 
              keyField='type' 
              data={this.motifStatisticsDataTable(mi)}
              columns={this.motifStatisticsColumns()} 
              bootstrap4={true} 
              bordered={false}
              classes="data-table"
              />
          </td>
          <td style={{width:remainingWidth, paddingRight:"15px", backgroundColor:(mi === currentMotifIdx)?"rgba(0,0,0,0.025)":"#fff"}}>
            <form className="navbar-form navbar-right" role="button" style={{}}>
              <span style={{whiteSpace:"nowrap", fontSize:"0.9em"}}>
                <Button 
                  className="btn-download btn-xs" 
                  color="success" 
                  name="downloadSVG" 
                  data-id={"SVG"}
                  data-idx={mi} 
                  onClick={this.handleClick} >
                  <FaDownload /> SVG
                </Button>
              </span>
            </form>
          </td>
        </tr>
      );
    });
  }
  
  motifStatisticsColumns = () => {
    //const indexWidth = 40;
    const seqlogoWidth = (this.state.clientWidth) ? parseInt(this.state.clientWidth)/3 : 600;
    const typeWidth = "100px";
    const scoreWidth = ((seqlogoWidth/2) + 50) + "px";
    //console.log("motifStatisticsColumns")
    //console.log(`${indexWidth}, ${seqlogoWidth}, ${typeWidth}, ${scoreWidth}`);
    const columns = [
      {
        dataField: 'type',
        text: '',
        headerStyle: {
          maxHeight: '1px',
          height: '1px',
          width: typeWidth,
          //borderBottom: '1px solid #b5b5b5',
        },
        style: {
          fontSize: '0.8em',
          fontWeight: 600,
          width: typeWidth,
          outlineWidth: '0px',
          marginLeft: '4px',
          paddingTop: '3px',
          paddingBottom: '3px',
          textAlign: 'left',
        },
        sort: false,
        sortFunc: (a, b, order, dataField) => {
          if (order === 'asc') {
            return b.localeCompare(a);
          }
          else {
            return a.localeCompare(b); // desc
          }          
        },
        sortCaret: (order, column) => {
          switch (order) {
            case "asc":
              return <div><ReactTooltip key="column-sort-state-asc" id="column-sort-state-asc" aria-haspopup="true" place="right" type="dark" effect="float">Sort statistic type in descending order</ReactTooltip><div data-tip data-for={"column-sort-state-asc"}><FaChevronCircleDown className="column-sort-defined" /></div></div>
            case "desc":
              return <div><ReactTooltip key="column-sort-state-desc" id="column-sort-state-desc" aria-haspopup="true" place="right" type="dark" effect="float">Sort statistic type in ascending order</ReactTooltip><div data-tip data-for={"column-sort-state-desc"}><FaChevronCircleUp className="column-sort-defined" /></div></div>
            case "undefined":
            default:
              return <div><ReactTooltip key="column-sort-state-undefined" id="column-sort-state-undefined" aria-haspopup="true" place="right" type="dark" effect="float">Sort by statistic type</ReactTooltip><div data-tip data-for={"column-sort-state-undefined"}><FaChevronCircleDown className="column-sort-undefined" /></div></div>
          }
        }
      },
      {
        dataField: 'score',
        text: '',
        headerStyle: {
          maxHeight: '1px',
          height: '1px',
          width: scoreWidth,
          borderBottom: '1px solid #b5b5b5',
        },
        style: {
          fontFamily: '"Consolas", "Input Mono", "Monaco", "Menlo", "Courier New", Courier, monospace',
          fontWeight: 'normal',
          fontSize: '0.8em',
          outlineWidth: '0px',
          paddingTop: '4px',
          paddingBottom: '3px',
          paddingRight: '2px',
          width: scoreWidth,
        },
        sort: false,
        sortCaret: (order, column) => {
          switch (order) {
            case "asc":
              return <div><ReactTooltip key="column-sort-element-asc" id="column-sort-element-asc" aria-haspopup="true" place="right" type="dark" effect="float">Sort statistic value in ascending order</ReactTooltip><div data-tip data-for={"column-sort-element-asc"}><FaChevronCircleDown className="column-sort-defined" /></div></div>
            case "desc":
              return <div><ReactTooltip key="column-sort-element-desc" id="column-sort-element-desc" aria-haspopup="true" place="right" type="dark" effect="float">Sort statistic value in descending order</ReactTooltip><div data-tip data-for={"column-sort-element-desc"}><FaChevronCircleUp className="column-sort-defined" /></div></div>
            case "undefined":
            default:
              return <div><ReactTooltip key="column-sort-element-undefined" id="column-sort-element-undefined" aria-haspopup="true" place="right" type="dark" effect="float">Sort statistic values</ReactTooltip><div data-tip data-for={"column-sort-element-undefined"}><FaChevronCircleDown className="column-sort-undefined" /></div></div>
          }
        }
      }
    ];
    //console.log(`${JSON.stringify(columns)}`);
    return columns;
  }
  
  jumpToAnchor(a) {
    //const url = document.URL;
    const cleanURL = document.URL.split('#')[0];
    const newURL = `${cleanURL}#${a}`;
    window.location.replace(newURL);
  }
  
  render() {
    
    const self = this;
    
    const openClose = function(val, name) {
      return (val) ? 
        <div onClick={()=>{self.flipOpenClose(name)}} style={{position:"relative", top:"4px", paddingRight:"4px"}}>&#9660;</div> 
        : 
        <div onClick={()=>{self.flipOpenClose(name)}} style={{position:"relative", top:"4px", paddingRight:"4px"}}>&#9654;</div>
    }
    
    return (
      <div id="viewer-container-no-margin" className="viewer-container-no-margin" ref="viewerContainer">
        
        <ReactTooltip 
          id="location-tooltip" 
          className="location-tooltip" 
          delayHide={100} 
          type="dark" 
          effect="solid" 
          html={true} />
        
        <div id="view-container-tooltip" className="view-container-tooltip" style={{position:"absolute", display:"none", zIndex:"1001"}} />
        
        <div>{((this.props.dataState === "valid") && (this.state.memeJSON)) ? 
          <div className={this.props.archiveURL === "" ? 'hidden' : ''}>

            <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
              <span style={{fontSize:"0.9em", fontWeight:"400"}}><FaHome className="brand-content-text-viewer-home" onClick={(e)=>{window.location=Constants.epilogosMemeURL}} /> epilogos MEME</span><br />
              <span style={{fontSize:"1.5em", fontWeight:"600"}}>{this.props.description.replace(/_/g, ' ')}</span>
            </div>
            
            {(this.state.memeDataAvailable) ? 
              
              <div>
              
                <div style={{paddingLeft:"15px", marginTop:"25px"}}>
                  <span onClick={()=>{this.jumpToAnchor('analysisSummary')}} style={{cursor:"pointer", textDecoration:"underline", color:"rgb(0,0,238)"}}>Analysis summary</span> | <span onClick={()=>{this.jumpToAnchor('motifs')}} style={{cursor:"pointer", textDecoration:"underline", color:"rgb(0,0,238)"}}>Discovered motifs</span> | <span onClick={()=>{this.jumpToAnchor('motif')}} style={{cursor:"pointer", textDecoration:"underline", color:"rgb(0,0,238)"}}>Motif {this.state.currentMotifIdx + 1}</span> | <span style={{display:(this.state.visible.motifLocations ? "inline-block" : "none")}}><span onClick={()=>{this.jumpToAnchor('motifLocations')}} style={{cursor:"pointer", textDecoration:"underline", color:"rgb(0,0,238)"}}>Motif locations</span> |</span> <span onClick={()=>{this.jumpToAnchor('downloads')}} style={{cursor:"pointer", textDecoration:"underline", color:"rgb(0,0,238)"}}>Downloads</span>
                </div>
              
                <div style={{marginTop:"25px"}}>
                  <h3 ref='analysisSummary' style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.jobSummary, "jobSummary")} </span>
                    Analysis summary
                  </h3>
                  <Collapse isOpen={this.state.openClose.jobSummary} style={{paddingLeft:"15px"}}>
                    <Card id="analysisSummary-table-card">
                      <CardBody>
                        <CardText tag="div">
                          { this.jobSummary() }
                        </CardText>
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
              
                <div style={{marginTop:"25px"}}>
                  <h3 ref='motifs' style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.discoveredMotifs, "discoveredMotifs")} </span>
                    Discovered motifs
                  </h3>
                  <Collapse isOpen={this.state.openClose.discoveredMotifs} style={{paddingLeft:"15px"}}>
                    <Card id="motif-table-card">
                      <CardBody>
                        <CardText tag="div">
                          { this.motifTable() }
                        </CardText>
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
                
                <div style={{marginTop:"25px"}}>
                  <h3 ref='motif' style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.motifDetails, "motifDetails")} </span>
                    Motif {this.state.currentMotifIdx + 1}
                  </h3>
                  <Collapse isOpen={this.state.openClose.motifDetails} style={{paddingLeft:"15px"}}>
                    <Card>
                      <CardBody>
                        <CardText tag="div">
                          
                          <div style={{}}>
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.motifConsensusSequence, "motifConsensusSequence")} </span>
                              Consensus sequence
                            </h3>
                            <Collapse isOpen={this.state.openClose.motifConsensusSequence} style={{paddingLeft:"15px"}}>
                              { this.consensusSequence(this.state.currentMotifIdx) }
                            </Collapse>
                          </div>
                          
                          <div style={{marginTop:"15px"}}>
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.motifSites, "motifSites")} </span>
                              Sites
                            </h3>
                            <Collapse isOpen={this.state.openClose.motifSites} style={{paddingLeft:"15px"}}>
                              { this.sitesTable(this.state.currentMotifIdx) }
                            </Collapse>
                          </div>
                          
                        </CardText>
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
                
                <div style={{marginTop:"25px",display:(this.state.visible.motifLocations ? "inline-block" : "none")}}>
                  <h3 ref='motifLocations' style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.motifLocations, "motifLocations")} </span>
                    Motif locations
                  </h3>
                  <Collapse isOpen={this.state.openClose.motifLocations} style={{paddingLeft:"15px"}}>
                    <Card>
                      <CardBody>
                        <CardText tag="div">
                        
                          <div style={{}}>
                          
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.motifLocationSites, "motifLocationSites")} </span>
                              Sites
                            </h3>

                            <Collapse isOpen={this.state.openClose.motifLocationSites} style={{paddingLeft:"15px"}}>
                            
                              <div style={{display:"inline-block", marginTop:"5px"}}>
                                
                                <div style={{display:"inline-block", paddingLeft:"20px"}} className="location-selector" data-name="viewMotifLocations" onClick={(e)=>{this.handleLocationsClick("viewMotifLocations")}}>{(this.state.currentLocationSelection === "viewMotifLocations") ? <FaRegDotCircle className="fa-accessible-icon" /> : <FaRegCircle className="fa-accessible-icon" />} <span style={{position:"relative", top:"2px"}}>All Motifs</span></div>
                                
                                <div style={{display:"inline-block", paddingLeft:"20px"}} className="location-selector" data-name="viewMotifAndScannedLocations" onClick={(e)=>{this.handleLocationsClick("viewMotifAndScannedLocations")}}>{(this.state.currentLocationSelection === "viewMotifAndScannedLocations") ? <FaRegDotCircle className="fa-accessible-icon" /> : <FaRegCircle className="fa-accessible-icon" />} <span style={{position:"relative", top:"2px"}}>All Motifs + Scanned</span></div>
                                
                                <div style={{display:"inline-block", paddingLeft:"20px"}} className="location-selector" data-name="viewAllLocations" onClick={(e)=>{this.handleLocationsClick("viewAllLocations")}}>{(this.state.currentLocationSelection === "viewAllLocations") ? <FaRegDotCircle className="fa-accessible-icon" height={"16px"} width={"16px"} /> : <FaRegCircle className="fa-accessible-icon" />} <span style={{position:"relative", top:"2px"}}>All Locations</span></div>
                                
                              </div>
                              
                              { this.locationsTable(this.state.currentLocationSelection) }                            
                            </Collapse>

                          </div>
                          
                        </CardText>
                      </CardBody>
                    </Card>
                  </Collapse>
                </div>
                
                <div style={{marginTop:"25px", marginBottom:"25px"}}>
                  <h3 ref="downloads" style={{fontSize:"larger", display:"flex"}}>
                    <span className="hide-show">{openClose(this.state.openClose.downloads, "downloads")} </span>
                    Downloads
                  </h3>
                  <Collapse isOpen={this.state.openClose.downloads} style={{paddingLeft:"15px"}}>
                    <Card>
                      <CardBody>
                        <CardText tag="div">
                          
                          <div style={{}}>
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.epilogosMEMEDownloads, "epilogosMEMEDownloads")} </span>
                              Epilogos MEME
                            </h3>
                            <Collapse isOpen={this.state.openClose.epilogosMEMEDownloads} style={{paddingLeft:"15px"}}>
                              <form className="navbar-form navbar-right" role="button" style={{marginBottom:"15px"}}>
                                <Button 
                                  size="sm"
                                  className="btn-download" 
                                  color="success" 
                                  name="downloadResults" 
                                  ref={(thisButton) => {this.downloadResultsButton = thisButton}} 
                                  onClick={this.handleClick} >
                                  <FaDownload /> Summary (bz2)
                                </Button>
                                <Button 
                                  size="sm"
                                  style={{marginLeft:"10px"}}
                                  className="btn-download" 
                                  color="success" 
                                  name="downloadJSONEpilogosMEME" 
                                  ref={(thisButton) => {this.downloadJSONButton = thisButton}} 
                                  onClick={this.handleClick} >
                                  <FaDownload /> JSON
                                </Button>
                              </form>
                            </Collapse>
                          </div>
                          
                          <div style={{marginTop:"30px"}}>
                            <h3 style={{fontSize:"larger", display:"flex"}}>
                              <span className="hide-show">{openClose(this.state.openClose.analysisDownloads, "analysisDownloads")} </span>
                              Analysis
                            </h3>
                            <Collapse isOpen={this.state.openClose.analysisDownloads} style={{paddingLeft:"15px"}}>
                              <form className="navbar-form navbar-right" role="button" style={{marginBottom:"15px"}}>
                                <Button 
                                  size="sm"
                                  style={{}}
                                  className="btn-download" 
                                  color="success" 
                                  name="downloadJSONAnalysis" 
                                  ref={(thisButton) => {this.downloadJSONButton = thisButton}} 
                                  onClick={this.handleClick} >
                                  <FaDownload /> JSON
                                </Button>
                              </form>
                            </Collapse>
                          </div>
                          
                        </CardText>
                      </CardBody>
                    </Card>
                    
                  </Collapse>
                </div>
                
              </div>
            : ((this.props.dataState === "valid") && (!this.state.memeMotifs)) ?
            
              <div style={{paddingLeft:"15px", paddingTop:"15px"}}>
                <Spinner color="dark" />
              </div>
            
            : 

              <div style={{paddingLeft:"15px", paddingTop:"15px"}}>
                <Spinner color="dark" />
              </div>
              
            }
            
          </div>
          
          :
          
          (this.state.jobMetadata) ?

            <div>
              <div className="viewer-container-no-margin" ref="viewerContainer">
                <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
                  <span style={{fontSize:"0.9em", fontWeight:"400"}}><FaHome className="brand-content-text-viewer-home" onClick={(e)=>{window.location=Constants.epilogosMemeURL}} /> epilogos MEME</span><br />
                  <span style={{fontSize:"1.5em", fontWeight:"600"}}>Report (A)</span>
                </div>
                <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
                  <div style={{paddingTop:"10px"}}>
                    Analysis results are not yet available for this id, or the analysis results cannot be found.
                  </div>
                  <div style={{paddingTop:"10px"}}>
                    Please check your email for updated status on your <em>epilogos MEME</em> job, or use the <span onClick={() => this.handleAnchorClick({href:Constants.rootURL})}><span className="anchor-text">job designer</span></span> to submit a new analysis.
                  </div>
                </div>
              </div>
            </div>
          
          :
          
          (this.state.motifKey !== -1) ?
          
            <div style={{paddingLeft:"15px", paddingTop:"15px"}}>
              <Spinner color="dark" />
            </div>
            
          :
          
            <div>
              <div className="viewer-container-no-margin" ref="viewerContainer">
                <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
                  <span style={{fontSize:"0.9em", fontWeight:"400"}}><FaHome className="brand-content-text-viewer-home" onClick={(e)=>{window.location=Constants.epilogosMemeURL}} /> epilogos MEME</span><br />
                  <span style={{fontSize:"1.5em", fontWeight:"600"}}>Report</span>
                </div>
                <div style={{paddingLeft:"15px", paddingTop:"10px"}}>
                  <div style={{paddingTop:"10px"}}>
                    Analysis results are not yet available for this id ({this.props.uuid}), or the analysis results cannot be found.
                  </div>
                  <div style={{paddingTop:"10px"}}>
                    Please check your email for updated status on your <em>epilogos MEME</em> job, or use the <span onClick={() => this.handleAnchorClick({href:Constants.rootURL})}><span className="anchor-text">job designer</span></span> to submit a new analysis.
                  </div>
                </div>
              </div>
            </div>

        }
        </div>
      </div>
    );
  }
}

export default ViewPanelV2;